// lib
import { createAction } from "@reduxjs/toolkit";

export const backTokenRequest = createAction("user/back/token/request");
export const backTokenSuccess = createAction("user/back/token/success");
// failure action not used per se
export const setRedirect = createAction("user/redirect/set");
export const resetRedirect = createAction("user/redirect/reset");
export const authAborted = createAction("user/auth/aborted");
export const authRejected = createAction("user/auth/rejected");
export const disconnect = createAction("user/disconnect");

// Network callbacks
export const userStateRequest = createAction("user/state/request");
export const userStateSuccess = createAction("user/state/success");
export const userStateFailure = createAction("user/state/failure");
